module.exports = __webpack_public_path__ + "img/jobmule_giornata_di_lavoro.7a93ee31.png";